// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Amplify } from '@aws-amplify/core';
import { list as listInternal } from './internal/list';
export function list(input) {
    return listInternal(Amplify, input ?? {});
}
